import React, { createRef, useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { translate } from "reducers/i18n";

const OtpInput = ({ handleSubmit, isSubmitting, render, tokenLength = 6, returnToken=()=>{}, error }) => {
  const inputRefs = useRef(new Array(tokenLength).fill(null));
  const [values, setValues] = useState(new Array(tokenLength).fill(""));
  const [focusedIndex, setFocusedIndex] = useState(0);
  for (let i = 0; i < tokenLength; i++) inputRefs.current[i] = createRef();

  useEffect(() => {
    inputRefs.current[0].current.focus();
  }, []);

  useEffect(() => {
    returnToken(values.join(""));
    const token = values.join("");
    const tokenIsValid = new RegExp(`^[0-9]{${tokenLength}}$`).test(token);
    const lastNumberEntered = focusedIndex === tokenLength - 1;
    const cursorIsAfterDigit = inputRefs.current[tokenLength - 1].current.selectionStart === 1;

    if (tokenIsValid && lastNumberEntered && cursorIsAfterDigit) {
      handleSubmit(token);
    }
  }, [values]);

  const handleChange = e => {
    const { name, selectionStart, value } = e.target;
    const [field, index] = name.split(".");
    const digit = selectionStart === 1 ? value[0] : value[1];
    const valueIsInvalid = Number.isNaN(Number.parseInt(digit));
    if (field !== "tokenInput" || valueIsInvalid) return;

    setValues(prev => {
      const updateArray = [...prev];
      updateArray[index] = digit;
      return updateArray;
    });

    if (index < inputRefs.current.length - 1) {
      inputRefs.current[Number.parseInt(index) + 1].current?.focus();
    }
  };

  const handleKeyDown = e => {
    const { key } = e;
    const { name, selectionStart } = e.target;
    const [field, index] = name.split(".");
    if (field !== "tokenInput") return;

    if (key === "Enter") {
      const token = values.join("");
      return void handleSubmit(token);
    }

    if (key === "Backspace") {
      setValues(prev => {
        const updateArray = [...prev];
        if (index - 1 > -1 && selectionStart === 0) updateArray[index - 1] = "";
        else if (index - 1 > -1 && selectionStart === 1) updateArray[index] = "";
        return updateArray;
      });

      if (index > 0 && key === "Backspace" && selectionStart === 0) {
        inputRefs.current[Number.parseInt(index) - 1].current.focus();
      }

      e.preventDefault();
    } else if (key === "Delete" && selectionStart === 0) {
      setValues(prev => {
        const updateArray = [...prev];
        updateArray[index] = "";
        return updateArray;
      });

      e.preventDefault();
    } else if (key === "ArrowLeft" && selectionStart === 0 && index > 0) {
      inputRefs.current[Number.parseInt(index) - 1].current.focus();
    } else if (
      key === "ArrowRight" &&
      (selectionStart === 1 || !values[index]) &&
      index < inputRefs.current.length - 1
    ) {
      inputRefs.current[Number.parseInt(index) + 1].current?.focus();
    }
  };

  const handleClick = async () => {
    const token = values.join("");
    handleSubmit(token);
  };

  return (
    <>
      <div className="d-flex justify-content-center py-3">
        {inputRefs.current.map((ref, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            enterkeyhint={translate('_submit')}
            className={classnames("form-control text-center", {
              "mr-2": index < inputRefs.current.length - 1
            })}
            name={`tokenInput.${index}`}
            onChange={handleChange}
            onFocus={() => setFocusedIndex(index)}
            onKeyDown={handleKeyDown}
            ref={el => (ref.current = el)}
            style={{ maxWidth: "2.5rem", fontSize: "1.5rem" }}
            value={values[index] || ""}
          />
        ))}
      </div>
      {error && (
        <div className="text-danger text-center mt-2">
          {error}
        </div>
      )}
      {render ? (
        render(values.join(""))
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = state => state.i18n;
export default connect(mapStateToProps)(OtpInput);
